import React, { useMemo, useRef, useState, useEffect } from 'react'
import {
  Row,
  Col,
  Table,
  Form
} from '@themesberg/react-bootstrap'
import PaginationComponent from '../../../components/Pagination'
import Trigger from '../../../components/OverlayTrigger'
import useSubCategoryListing from './useSubCategoryListing'
import { tableHeaders } from './constants'
import ConfirmationModal from '../../../components/ConfirmationModal'
import { Button } from 'react-bootstrap'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faBan, faCheckSquare, faEdit, faPlus, faTrash, faWindowClose } from '@fortawesome/free-solid-svg-icons'
import useCheckPermission from '../../../utils/checkPermission'
import CreateCasinoCategory from './components/CreateCasinoCategory'
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded'
import { motion } from 'framer-motion/dist/framer-motion'
import ActionMenu from './ActionMenu'
import { ReorderOutlined } from '@mui/icons-material'
import NotificationIconContainer from '../../../components/NotificationIcon/NotificationIconContainer'
import useTableCustom from "../../../components/CusotmFilter"
import TableErrorMessage from '../../../components/TableErrorMessage'
import ImageModal from "../../../components/ImageModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons'



export default () => {
  const {
    limit,
    setLimit,
    page,
    setPage,
    loading,
    totalPages,
    gameSubCategory,
    getGameName,
    search,
    setSearch,
    active,
    setActive,
    gameCategory,
    popularGames,
    categoryId,
    setCategoryId,
    handleClose,
    handleShow,
    handleStatusShow,
    handleYes,
    show,
    statusShow,
    setStatusShow,
    status,
    navigate,
    name,
    data,
    type,
    createCategory,
    updateCategory,
    handleDeleteItems,
    languages,
    language,
    setLangauge,
    handleNewGame,
    imageModal, setImageModal,
    handleResetFilters,
    totalCount
  } = useSubCategoryListing()
  const { isHidden } = useCheckPermission()

  const isShowActionColumnCG =
    !isHidden({ module: { key: "CasinoManagement", value: "U" } }) ||
    !isHidden({ module: { key: "CasinoManagement", value: "T" } });


  const dynamicTableHeaders = useMemo(() => {
    const headers = [...tableHeaders.filter(col => col.value !== 'action')];
    if (isShowActionColumnCG) {
      headers.push({
        accessorKey: 'action',
        Header: 'Actions',
        value: 'action',
        label: 'Actions',
      });
    }
    console.log({ headers, isShowActionColumnCG }, "dyncamicc ..>>   tableHeaders >> casino gamness")

    return headers;
  }, [isShowActionColumnCG]);


  const {
    visibleColumns,
    pageData,
    customColSetting,
    noDataFound,
    resetColumns
  } = useTableCustom(
    popularGames?.rows,
    dynamicTableHeaders, // already permission-filtered
    false,
    () => { },
    null,
    null,
    false,
    "",
    true,
    "NEW_GAMES_TABLE"
  );


  const headerRef = useRef(null);
  const filterRef = useRef(null);
  const paginationRef = useRef(null);
  const [tableMaxHeight, setTableMaxHeight] = useState("");


  useEffect(() => {
    const updateMaxHeight = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const filterHeight = filterRef.current?.offsetHeight || 0;
      const paginationHeight = paginationRef?.current?.offsetHeight || 0;

      const responsiveTable = document.querySelector('.table-responsive');
      const totalHeight = headerHeight + filterHeight + paginationHeight;
      const availableHeight = window.innerHeight - totalHeight - 150;

      if (window.innerWidth < 1000) {
        // For smaller screens: reset to full height
        if (responsiveTable) {
          responsiveTable.style.maxHeight = '100%';
          responsiveTable.style.overflowY = 'unset';
        }
        setTableMaxHeight('100%');
        return;
      }
      else if (responsiveTable) {
        responsiveTable.style.maxHeight = `${availableHeight}px`;
        responsiveTable.style.overflowY = 'auto'; // ensure scrolling
        setTableMaxHeight(`${availableHeight}px`);
      }


    };

    updateMaxHeight();
    window.addEventListener("resize", updateMaxHeight);
    return () => window.removeEventListener("resize", updateMaxHeight);
  }, [visibleColumns, tableHeaders]);

  return (
    <>


      <div className="section-header-wrap mt-n3 mx-n3" ref={headerRef}>
        <Row className="align-items-center">
          {/* Title on the left */}
          <Col xs={12} lg={6}>
            <h2 className="title-text mb-0">New Games</h2>
          </Col>

          {/* Dropdown + Notification on the right */}
          <Col xs={12} lg={6} className="d-flex justify-content-lg-end  align-items-center justify-content-start gap-2 mt-2 mt-lg-0">

            <NotificationIconContainer />
          </Col>
        </Row>
      </div>

      <div className='FormsBg' ref={filterRef}>
        <Row>
          {/* <Col xs={3}>
          <div className='d-flex justify-content-start align-items-center w-100'>
       

            <Form.Select
              onChange={(e) => setCategoryId(e.target.value)}
              value={categoryId}
              style={{ marginBottom: '5px' }}
            >
              <option value=''>Category</option>
              {gameCategory && gameCategory?.rows?.map(({ gameCategoryId, name }) => {
                return <option key={gameCategoryId} value={gameCategoryId}>{name?.EN}</option>
              })}
            </Form.Select>
          </div>
        </Col> */}

          <Col xs={12} md={4} lg={3}>
            <div className='d-flex justify-content-start align-items-center w-100'>


              <Form.Control
                type='search'
                value={search}
                placeholder='Search by Game Name'
                size='sm'
                onChange={(event) => setSearch(event.target.value)}
              />
            </div>
          </Col>

          {/* <Col xs={3}>
          <div className='d-flex justify-content-start align-items-center w-100'>
          

            <Form.Select
              onChange={(e) => setActive(e.target.value)}
              value={active}
            >
              <option value=''>Status</option>
              <option value='true'>Active</option>
              <option value='false'>In-Active</option>
            </Form.Select>
          </div>
        </Col> */}

        </Row>

        <Row className="g-2 align-items-center mt-2 mt-md-0">
          <Col xs={12} md={10} lg={9}>
            <div className="d-flex flex-column flex-sm-row justify-content-start gap-2 w-100">
              <div className="order-2 order-md-1">
                <Button
                  className="d-flex align-items-center btn-primary gap-3"
                  style={{ height: '2.2rem', minWidth: 'max-content' }}
                  size="sm"
                  onClick={() => {
                    handleResetFilters()
                    resetColumns()
                  }}
                >
                  <span>Reset Filters</span>
                  <FontAwesomeIcon icon={faRedoAlt} />
                </Button>
              </div>

            </div>
          </Col>
          <Col xs={12} md={2} lg={3}>
            <div className="d-flex justify-content-start justify-content-md-end">
              {customColSetting}
            </div>
          </Col>
        </Row>


      </div>
      {visibleColumns?.length > 0 ? <div className='TableBg mt-4 pt-1'>

        <Table striped responsive hover size='sm' className='text-center mt-3'>
          <thead className='thead-light'>
            <tr>
              {visibleColumns.map((h, idx) => (
                <th
                  key={idx}
                >
                  {h.label}
                </th>
              ))}
            </tr>
          </thead>

          {/* <tbody id={loading ? 'cover-spin' : ''}>
            {popularGames && popularGames?.rows?.length > 0 && !loading &&
              popularGames?.rows?.map(
                (
                  {
                    id: gameSubCategoryId,
                    casinoGameId,
                    name,
                    category: categoryName,
                    trans,
                    isActive,
                    videoSnapshot: thumbnailUrl,

                    isGlobal
                  }, index
                ) => {
                  return (
                    <tr key={index}>
                      <td>{casinoGameId}</td>
                      <td>
                        <Trigger message={name}>
                          <span
                            style={{
                              width: '200px',
                              cursor: 'pointer'
                            }}
                            className='d-inline-block text-truncate'
                          >
                            {name}
                          </span>
                        </Trigger>
                      </td>

                      <td>
                        <Trigger message={name}>
                          <span
                            style={{
                              width: '100px',
                              cursor: 'pointer'
                            }}
                            className='d-inline-block text-truncate'
                          >
                            {categoryName}
                          </span>
                        </Trigger>
                      </td>

                      <td>
                        <span
                          onClick={() => window.open(
                            thumbnailUrl.evolutionImage ?
                              process.env.REACT_APP_S3_URL + '/' + thumbnailUrl.evolutionImage :
                              process.env.REACT_APP_EVOLUTION_URL + thumbnailUrl.links['M']
                          )}
                          className='text-link'
                          style={{ cursor: 'pointer' }}
                        >
                          View Here
                        </span>
                      </td>

                      <td>
                        <ActionMenu
                          isHidden={isHidden}
                          handleShow={handleShow}
                          isActive={isActive}
                          name={name}
                          index={index}
                          isGlobal={isGlobal}
                          handleStatusShow={handleStatusShow}
                          gameSubCategory={gameSubCategory}
                          gameSubCategoryId={casinoGameId}
                          handleDeleteItems={handleDeleteItems}
                          handleNewGame={handleNewGame}
                          casinoPopularId={casinoGameId}
                        />
                      </td>
                    </tr>
                  )
                }
              )}

            {gameSubCategory?.count === 0 && !loading &&
              (
                <tr>
                  <td
                    colSpan={5}
                    className='text-danger text-center'
                  >
                    No data found
                  </td>
                </tr>
              )}
          </tbody> */}
          <tbody id={loading ? 'cover-spin' : ''}>
            {!loading && popularGames?.rows?.length > 0 &&
              popularGames.rows.map((row, index) => (
                <tr key={index}>
                  {visibleColumns.map((col, cIdx) => {
                    const key = col.accessorKey;
                    switch (key) {
                      case 'casinoGameId':
                        return <td key={cIdx}>{row.casinoGameId}</td>;

                      case 'name':
                        return (
                          <td key={cIdx}>
                            <Trigger message={row.name}>
                              <span
                                style={{ width: '200px', cursor: 'pointer' }}
                                className='d-inline-block text-truncate'
                              >
                                {row.name}
                              </span>
                            </Trigger>
                          </td>
                        );

                      case 'categoryname':
                        return (
                          <td key={cIdx}>
                            <Trigger message={row.name}>
                              <span
                                style={{ width: '100px', cursor: 'pointer' }}
                                className='d-inline-block text-truncate'
                              >
                                {row.category}
                              </span>
                            </Trigger>
                          </td>
                        );

                      case 'thumbnail':
                        const thumbUrl = row.videoSnapshot?.evolutionImage
                          ? `${process.env.REACT_APP_S3_URL}/${row.videoSnapshot.evolutionImage}`
                          : `${process.env.REACT_APP_EVOLUTION_URL}${row.videoSnapshot?.links?.M}`;
                        return (
                          <td key={cIdx}>
                            <span
                              // onClick={() => window.open(thumbUrl)}
                              onClick={() => setImageModal({
                                isOpen: true,
                                url: thumbUrl,
                              })}
                              className='text-link'
                              style={{ cursor: 'pointer' }}
                            >
                              <img src={`${thumbUrl}`}
                                style={{ width: '100px', height: 'auto', objectFit: 'contain', cursor: 'pointer' }}
                              />
                            </span>
                          </td>
                        );

                      case 'action':
                        return (
                          <td key={cIdx}>
                            <ActionMenu
                              isHidden={isHidden}
                              handleShow={handleShow}
                              isActive={row.isActive}
                              name={row.name}
                              index={index}
                              isGlobal={row.isGlobal}
                              handleStatusShow={handleStatusShow}
                              gameSubCategory={gameSubCategory}
                              gameSubCategoryId={row.casinoGameId}
                              handleDeleteItems={handleDeleteItems}
                              handleNewGame={handleNewGame}
                              casinoPopularId={row.casinoGameId}
                            />
                          </td>
                        );

                      default:
                        return <td key={cIdx}>{row[key] ?? '--'}</td>;
                    }
                  })}
                </tr>
              ))}

            {popularGames?.count === 0 && !loading && (
              <tr>
                <td colSpan={visibleColumns.length} className='text-danger text-center'>
                  No data found
                </td>
              </tr>
            )}
          </tbody>

        </Table>
        {gameSubCategory?.count !== 0 && !loading && popularGames?.count > 0 &&
          (
            <PaginationComponent
              page={gameSubCategory?.count < page ? setPage(1) : page}
              totalPages={totalPages}
              setPage={setPage}
              limit={limit}
              setLimit={setLimit}
              paginationRef={paginationRef}

              showTotalCount={true}
              totalCount={totalCount}
              countText={"Total New Games : "}


            />
          )}
      </div> : <TableErrorMessage />}
      {statusShow && <ConfirmationModal
        setShow={setStatusShow}
        show={statusShow}
        handleYes={handleYes}
        active={status}
        name={name}
      />}

      {show && <CreateCasinoCategory
        handleClose={handleClose}
        data={data}
        type={type}
        show={show}
        gameCategory={gameCategory}
        loading={loading}
        createProvider={createCategory}
        updateProvider={updateCategory}
        languages={languages}
        language={language}
        setLangauge={setLangauge}
      />}

      <ImageModal
        show={imageModal.isOpen}
        imageUrl={imageModal.url}
        altText="Preview"
        setShow={() => setImageModal({ ...imageModal, isOpen: false, url: '' })}
      />


    </>
  )
}
